import store from '@/store';

export default {
   path: '/multicotizador/art/',
   name: 'art',
   children: [
      {
         path: 'capitas',
         name: 'art/capitas',
         component: () =>
            import(
               /* webpackChunkName: "AltaClienteArt" */ '@/modules/art/views/ConsultaEmpresaView.vue'
            ),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            } else {
               next();
            }
         },
      },
      {
         path: 'archivos',
         name: 'art/archivos',
         component: () =>
            import(
               /* webpackChunkName: "AltaClienteArt" */ '@/modules/art/views/OpcionesArtView.vue'
            ),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }

            if (store.state.poliza.poliza.masa_salarial === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            } else {
               next();
            }
         },
      },
   ],
};
